import { useEffect, useState } from "react";
import { CrewTasksResponse } from "./types";
import apiService from "../../../service/Api";

export const getCrewMemberTasks = async (
  crewMemberId: number,
  date?: string,
): Promise<CrewTasksResponse> => {
  const params = date ? `?date=${date}` : "";

  const res = await apiService.get<CrewTasksResponse>(
    `/api/crews/crew-members/${crewMemberId}/assigned-tasks/${params}`,
  );

  return res.data;
};
export const useCrewTasks = (crewMemberId: number, date?: string) => {
  const [data, setData] = useState<CrewTasksResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTasks = async () => {
    try {
      setLoading(true);
      const res = await getCrewMemberTasks(crewMemberId, date);
      setData(res);
    } catch (err: unknown) {
      const message =
        err instanceof Error ? err.message : "Failed to fetch tasks";

      setError(message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (crewMemberId) {
      fetchTasks();
    }
  }, [crewMemberId, date]);

  return { data, loading, error, refetch: fetchTasks };
};
